module.exports = __webpack_public_path__ + "static/media/6.66d6a98e.jpg";